import type { FaireBrandEntity } from "../../entity_types/brand";

// Anonymized stand-in for the p6_churned archetype (real metrics, fake identity).
export const bAdvP6Churned: FaireBrandEntity = {
  token: "b_adv_p6_churned",
  type: "brand",
  name: "Lustre & Co.",
  description: "Waterproof stainless steel jewelry and charms",
  location: "Los Angeles, CA",
  rating: 4.7,
  minimumOrderDollars: 150,
  tags: ["jewelry", "waterproof", "accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
